// extracted by mini-css-extract-plugin
export default {"navigationContainer":"XzP01r","fixNavigationDotsPosition":"Pu42oS","navigation":"gOtyey"};